import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { fmtMoney } from './fmtMoney';

/**
 * Dark summary bar showing counts and dollar totals for selected lines.
 * Place below the line-items table; replaces the header "In Dispute: $X" text.
 */
export default function InDisputeBar({ lines = [], selectedLines = {} }) {
  let deniedCount = 0;
  let underpaidCount = 0;
  let sumBilled = 0;
  let sumPaid = 0;

  lines.forEach((ln) => {
    if (!selectedLines[ln.id]) return;
    if (ln.status === 'denied') deniedCount += 1;
    else if (ln.status === 'underpaid') underpaidCount += 1;
    sumBilled += parseFloat(ln.billed_amount || 0);
    sumPaid += parseFloat(ln.paid_amount || 0);
  });

  const dispute = sumBilled - sumPaid;
  const totalSelected = Object.keys(selectedLines).length;

  if (totalSelected === 0) return null;

  return (
    <Box
      data-testid="in-dispute-bar"
      sx={{
        mt: 1.5,
        px: 2.5,
        py: 1.5,
        bgcolor: 'var(--ab-fg, #111827)',
        borderRadius: 1,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 3,
        alignItems: 'center',
      }}
    >
      <Typography variant="caption" sx={{ color: 'var(--ab-fg-inverse, #fff)', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', fontSize: '0.68rem' }}>
        In Dispute
      </Typography>

      {deniedCount > 0 && (
        <Stat label="Denied" value={deniedCount} />
      )}
      {underpaidCount > 0 && (
        <Stat label="Underpaid" value={underpaidCount} />
      )}
      <Stat label="Charged" value={fmtMoney(sumBilled)} />
      <Stat label="Paid" value={fmtMoney(sumPaid)} />
      <Stat label="Dispute Total" value={fmtMoney(dispute)} highlight />
    </Box>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <Box>
      <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.55)', display: 'block', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ color: highlight ? '#FCD34D' : 'var(--ab-fg-inverse, #fff)', fontWeight: highlight ? 700 : 600, fontSize: '0.82rem' }}>
        {value}
      </Typography>
    </Box>
  );
}
